<template>
  <div class="cmp cmp-frame">
    <div class="frame-content">
      <div class="frame-content-inner">
        <slot></slot>
      </div>
    </div>
    <div class="frame-header">
      <div class="frame-header-label">
        {{ label }}
      </div>
      <div class="frame-header-info">
        {{ studyRequest }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cmp-frame",
  props: {
    label: String,
    studyRequest: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.cmp-frame {
  display: flex;
  margin-bottom: 30px;
  iframe {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
<style lang="less" scoped>
.cmp-frame {
  .frame-header {
    max-width: 340px;
    // height: 45px;
    // padding: 6px 13px;
    // border-radius: 5px 5px 0 0 e("/") 5px 5px 0 0;
    // background-color: #454356;
    // display: flex;
    // align-items: center;
    margin-left: 20px;

    .frame-header-label {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #464c5b;
      // white-space: nowrap;
      // overflow: hidden;
      // text-overflow: ellipsis;
      position: relative;
      padding-left: 10px;
      &::after {
        position: absolute;
        content: "";
        width: 4px;
        height: 70%;
        background: #19a4ff;
        border-radius: 6px;
        left: 0;
        top: 57%;
        transform: translateY(-50%);
      }
    }
    .frame-header-info {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #464c5b;
      line-height: 30px;
      margin-top: 10px;
      text-indent: 2em;
    }
  }
  .frame-content {
    width: 770px;
    height: 446px;
    background: #eff2f5;
    border-radius: 6px;
    .frame-content-inner {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
